<button
  #sortButton
  type="button"
  class="hover:bg-interactive hover:text-text-primary inline-flex cursor-pointer items-center gap-1.5 rounded-xs px-1.5 py-[3px] text-xs font-medium transition-colors outline-none focus-visible:shadow-(--shadow-focus)"
  [class.text-text-secondary]="sort().length === 0"
  [class.text-accent-main]="sort().length > 0"
  [class.bg-interactive]="menuOpen()"
  [attr.aria-label]="'features.data.path_filter.sort.button' | translate"
  [attr.aria-expanded]="menuOpen()"
  aria-haspopup="menu"
  (click)="menuOpen.set(!menuOpen())">
  <i [class]="ICONS.sortAscending" aria-hidden="true"></i
  >{{ 'features.data.path_filter.sort.button' | translate }}
  @if (sort().length > 0) {
    <span
      class="bg-accent-interactive text-accent-main rounded-full px-1.5 font-mono text-[10.5px] leading-4"
      >{{ sort().length }}</span
    >
  }
</button>
<app-dropdown
  [target]="sortButton"
  [template]="menu"
  [isOpen]="menuOpen()"
  [onClose]="closeMenu"
  [useDefaultStyles]="false" />

<ng-template #menu>
  <div class="g-menu w-64" role="menu" appFocusFirst (keydown)="onMenuKey($event)">
    @if (active().length > 0) {
      @for (entry of active(); track entry.index) {
        <div class="g-menu-item is-active cursor-default">
          <span class="text-text-tertiary w-3 shrink-0 font-mono text-[10.5px]">{{
            entry.index + 1
          }}</span>
          <span class="ellipsis flex-1">{{ entry.label }}</span>
          <button
            type="button"
            class="hover:bg-elevated inline-flex cursor-pointer rounded-xs p-1 outline-none focus-visible:shadow-(--shadow-focus)"
            [attr.aria-label]="'features.data.path_filter.sort.flip' | translate"
            (click)="flip(entry.index)">
            <i
              aria-hidden="true"
              [class]="
                entry.order === 'desc' ? ICONS.sortDescending : ICONS.sortAscending
              "></i>
          </button>
          <button
            type="button"
            class="text-text-tertiary hover:bg-elevated hover:text-text-primary inline-flex cursor-pointer rounded-xs p-1 outline-none focus-visible:shadow-(--shadow-focus)"
            [attr.aria-label]="'features.data.path_filter.sort.remove' | translate"
            (click)="remove(entry.index)">
            <i [class]="ICONS.x" aria-hidden="true"></i>
          </button>
        </div>
      }
      <button
        type="button"
        role="menuitem"
        class="g-menu-item focus-visible:bg-interactive w-full outline-none"
        (click)="clear()">
        <i [class]="ICONS.x" aria-hidden="true"></i>
        <span class="flex-1 text-left">{{
          'features.data.path_filter.sort.clear' | translate
        }}</span>
      </button>
      <div class="g-menu-divider"></div>
    }
    <div class="g-menu-label">{{ 'features.data.path_filter.sort.menu' | translate }}</div>
    <div class="g-menu-scroll">
      @for (option of options(); track option.key) {
        <button
          type="button"
          role="menuitem"
          class="g-menu-item focus-visible:bg-interactive w-full outline-none"
          (click)="add(option)">
          <span class="ellipsis flex-1 text-left">{{ option.label }}</span>
          @if (isSorted(option)) {
            <i [class]="ICONS.check" aria-hidden="true" class="text-accent-main"></i>
          }
        </button>
      }
    </div>
  </div>
</ng-template>
